import React from 'react';

function Section({ title, children }) {
  return (
    <section style={{ display: 'grid', gap: 8 }}>
      <h2 style={{ margin: '0 0 4px', fontSize: 20 }}>{title}</h2>
      <div style={{ color: 'var(--muted)', lineHeight: 1.6, fontSize: 15 }}>
        {children}
      </div>
    </section>
  );
}

export default function Privacy() {
  return (
    <div className="container" style={{ paddingTop: 32, paddingBottom: 48 }}>
      <div className="card" style={{ display: 'grid', gap: 24 }}>
        <div style={{ display: 'grid', gap: 8 }}>
          <p style={{ fontWeight: 700, color: 'var(--muted)', margin: 0 }}>Privacy Policy</p>
          <h1 style={{ margin: 0, fontSize: 28, letterSpacing: '-0.01em' }}>Sellantra</h1>
          <p style={{ margin: 0, color: 'var(--muted)' }}>Last updated: 2026-01-03</p>

          <p style={{ margin: 0, color: 'var(--muted)' }}>
            This Privacy Policy explains how Sellantra ("we", "us") collects, uses, and shares information when you use
            the Sellantra mobile and web applications, dashboards, and related services (collectively, the "Services").
            Sellantra is operated from India and we comply with applicable data protection laws.
          </p>
        </div>

        <Section title="Information we collect">
          <ul style={{ margin: 0, paddingLeft: 18, display: 'grid', gap: 8 }}>
            <li>
              Account and shop profile details you provide (shop/organisation name, email/phone, password, GSTIN, address,
              state code, logo).
            </li>
            <li>User and role details for access control (user name/email, assigned role/permissions).</li>
            <li>
              Business data you enter: products (name, SKU/barcode, price, GST rate, stock), customers (name, phone,
              email, address, GSTIN, state code, tags, store credit), invoices/sales, returns/credit notes, payment
              method labels (cash/UPI/card/credit) and amounts.
            </li>
            <li>
              App preferences stored on your device (e.g., pagination settings, selected camera for barcode scan, cached
              session tokens) to keep you signed in and remember choices.
            </li>
            <li>Technical logs from our servers and APIs (timestamps, IP, request metadata) to keep the service reliable and secure.</li>
            <li>Support communications when you contact us.</li>
            <li>
              Camera access only when you choose barcode/QR scanning; video is processed locally to decode the barcode
              and is not stored by us.
            </li>
          </ul>
        </Section>

        <Section title="How we use information">
          <ul style={{ margin: 0, paddingLeft: 18, display: 'grid', gap: 8 }}>
            <li>Provide billing/POS, inventory, returns, credit, and reporting features you request.</li>
            <li>Calculate GST correctly based on shop/customer state codes and your tax rates.</li>
            <li>Maintain your account, keep you signed in, and sync your business data across devices.</li>
            <li>Monitor stability, troubleshoot issues, prevent fraud/misuse, and secure the Services.</li>
            <li>Respond to support requests and send essential service updates.</li>
          </ul>
        </Section>

        <Section title="Payments and subscriptions">
          <p style={{ margin: 0 }}>
            The app records payment methods and amounts for your invoices (cash/UPI/card/credit) but does not process card or UPI payments itself. If we ever integrate a payment partner, card details will be handled directly by that provider and not stored by us.
          </p>
        </Section>

        <Section title="Sharing">
          <ul style={{ margin: 0, paddingLeft: 18, display: 'grid', gap: 8 }}>
            <li>
              Hosting, storage, and operational service providers that help us deliver the Services (bound by
              confidentiality and security obligations). Our servers are located in India.
            </li>
            <li>Contractors/affiliates working under similar privacy safeguards when needed to support you.</li>
            <li>Law enforcement or regulators if required by law or to protect rights, safety, or property.</li>
            <li>
              Business transfers (e.g., merger or acquisition); if this happens, we will continue to protect your data
              and notify you of material changes.
            </li>
          </ul>
          <p style={{ margin: '12px 0 0', color: 'var(--muted)' }}>We do not sell personal data.</p>
          <p style={{ margin: 0, color: 'var(--muted)' }}>
            We do not use advertising SDKs or third-party analytics SDKs in the app.
          </p>
        </Section>

        <Section title="Data retention">
          <p style={{ margin: 0 }}>
            We keep data while your account remains active and as needed to provide the Services, comply with law,
            resolve disputes, and enforce agreements. You may request deletion of your account by emailing us (see
            Contact). Some records (e.g., tax/accounting records) may need to be retained where legally required.
          </p>
          <p style={{ margin: '8px 0 0' }}>
            You can also delete your account directly in the app; see the{' '}
            <a href="/delete-account">Delete Account</a> page for steps and details on what is removed.
          </p>
        </Section>

        <Section title="Your choices & rights">
          <ul style={{ margin: 0, paddingLeft: 18, display: 'grid', gap: 8 }}>
            <li>Access, correct, or delete your account data by contacting us using the details below.</li>
            <li>
              Control permissions (e.g., camera for barcode scan) in your device settings; disabling some may limit
              features.
            </li>
            <li>Opt out of any marketing messages via the unsubscribe option or by emailing support.</li>
          </ul>
        </Section>

        <Section title="Security">
          <p style={{ margin: 0 }}>
            We use industry-standard safeguards (encryption in transit, access controls, role-based permissions) to
            protect data. No system is completely secure; please contact us immediately if you suspect an issue.
          </p>
        </Section>

        <Section title="Children">
          <p style={{ margin: 0 }}>
            The Services are not directed to children under 13 (or the minimum age required by local law). We do not
            knowingly collect personal information from children.
          </p>
        </Section>

        <Section title="Changes to this policy">
          <p style={{ margin: 0 }}>
            We may update this policy to reflect changes in our practices or for legal, technical, or regulatory
            reasons. Material changes will be noted with a revised "Last updated" date.
          </p>
        </Section>

        <Section title="Contact">
          <p style={{ margin: 0 }}>
            Questions or requests about privacy (including account deletion) can be sent to{' '}
            <a href="mailto:sujitsahu007@gmail.com">sujitsahu007@gmail.com</a>.
          </p>
          <p style={{ margin: 0, color: 'var(--muted)' }}>
            If you contact us, please include your account email or tenant ID so we can assist quickly.
          </p>
        </Section>
      </div>
    </div>
  );
}
